module.exports = __webpack_public_path__ + "assets/img/22.006609df.png";